import { getAll as getAllTiers } from '@/api/tiers/index';
import store from '@/store/store';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

export default async function getTiersByReferenceExterne(references) {
  const referencesFiltered = [...new Set(references)];
  if (referencesFiltered.length === 0) return [];

  const results = (await getAllTiers({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      referencesExterne: referencesFiltered,
    },
    MaxResultCount: NO_PAGINATION,
    limit: NO_PAGINATION,
    SkipCount: 0,
  })).data.result.items;
  const errors = [];
  referencesFiltered.forEach((tier) => {
    const isInResult = results.find((t) => t.referenceExterne === tier);
    if (!isInResult) errors.push({ message: 'importDonne.dataNotExist', parametres: { data: tier } });
  });
  if (errors.length > 0) throw errors;
  return results;
}
